import { IconProps } from './types'

export const ParametersIcon = ({ size, color }: IconProps) => {
  return (
    <svg
      width={size || '100%'}
      height={size || '100%'}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M14.0703 16.4996V12.5996"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0703 5.45V3.5"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4766 8.0502C11.4766 6.6102 12.6366 5.4502 14.0766 5.4502C15.5166 5.4502 16.6766 6.6102 16.6766 8.0502C16.6766 9.4902 15.5166 10.6502 14.0766 10.6502"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.92969 16.4998V14.5498"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.92969 7.4V3.5"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.92813 14.5496C8.36407 14.5496 9.52812 13.3855 9.52812 11.9496C9.52812 10.5137 8.36407 9.34961 6.92813 9.34961C5.49218 9.34961 4.32812 10.5137 4.32812 11.9496C4.32812 13.3855 5.49218 14.5496 6.92813 14.5496Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
